import React from 'react';
import { iconWrapper, InjectedProps } from '../iconWrapper';

interface Props extends InjectedProps {
  className?: string;
}

class Warning extends React.PureComponent<Props> {
  public render() {
    return (
      <svg
        className={['icon-svg', 'svg-warning', this.props.className].join(' ')}
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 16 17"
      >
        <path d="M9.64032 2.77668L15.0263 12.3058C15.9323 13.9086 15.1746 15.2079 13.3311 15.2079H2.66495C0.824946 15.2079 0.0647774 13.9138 0.973654 12.3058L6.35968 2.77668C7.2656 1.17389 8.73144 1.16867 9.64032 2.77668ZM8 11.5412C7.44771 11.5412 7 11.989 7 12.5412C7 13.0935 7.44771 13.5412 8 13.5412C8.55228 13.5412 9 13.0935 9 12.5412C9 11.989 8.55228 11.5412 8 11.5412ZM8.66667 5.20791H7.33333V9.87457H8.66667V5.20791Z" />
      </svg>
    );
  }
}

export const icon = iconWrapper(Warning);
